import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.originalText = this.element.textContent;
  }

  copy(event) {
    event.preventDefault();

    const urls = Array.from(
      document.querySelectorAll("tbody tr td:nth-child(2) a")
    )
      .map((link) => link.href)
      .join("\n");

    if (urls.length === 0) {
      alert("No URLs to copy");
      return;
    }

    navigator.clipboard
      .writeText(urls)
      .then(() => {
        // Set copied state
        this.element.dataset.copied = "true";

        // Reset button state after 1 second
        setTimeout(() => {
          this.element.dataset.copied = "false";
        }, 500);
      })
      .catch((error) => {
        console.error("Copy failed:", error);
        alert("Failed to copy URLs");
      });
  }
}
